<m27-page>
    <m27-page-body>
        <div *ngIf="show" style="text-align: center;">
            <div class="login-container">
                <div class="title">
                    Application Login
                </div>
                <div class="body">
                    <div class="dialog-icon lock"></div>
                    <div style="margin-left: 2px; width: 400px;">
                        <div style="margin-top: 8px;">Click the button below to log in to the application.</div>
                        <div style="font-size: .9em; ">You may be prompted for your LAN credentials.</div>
                        <div style="text-align: right; margin-top: 18px;">
                            <button automationid="userLoginComponent" (click)="login()" class="success">Login</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </m27-page-body>
</m27-page>
